import { Types } from '../../types';
import getType from './getType';

export const isEmpty = (value: any): boolean =>
  value === undefined ||
  value === null ||
  value === '' ||
  (getType(value) === Types.Array && value.length === 0) ||
  (getType(value) === Types.Object && Object.keys(value).length === 0) ||
  (getType(value) === Types.Set && value.size === 0) ||
  (getType(value) === Types.Map && value.size === 0);

export default isEmpty;
